/**
 * TAG-VÁLASZTÓ CÍMKE: „Név (e-mail)" — de CSAK ha az e-mail tényleg megjött [C10, 2026-10-30]
 *
 * MI VOLT A BAJ: a szerver 2026-10-30 óta nem-admin (edzői) hívónak MÁS tag e-mail-címét és
 * telefonszámát `null`-ként adja (`backend/PinyoApi/Services/UserListSanitizer.cs`
 * `HideAdminOnlyFields` — a `User.Email`/`User.Phone` `PersonalDataLevel.SosUnlockable` lett).
 * A web négy helyen sablon-szöveggel rakta össze a címkét (`${user.name} (${user.email})`):
 * `EventCreateDialog`, `EventEditDialog`, `EventAttendance` (walk-in választó) és
 * `TrainingBalance` — e-mail nélkül ebből „Kiss Anna (null)" lett volna, a MUI Autocomplete
 * pedig erre a szövegre is szűr („null"-ra keresve mindenki találat lett volna).
 *
 * A SZABÁLY: van nem üres e-mail → „Név (e-mail)" (admin: VÁLTOZATLAN); nincs → csak „Név".
 * NEM találunk ki helyette más azonosítót (pl. a userId elejét): két azonos nevű tag edzőnél
 * ilyenkor ugyanazzal a címkével látszik — ez nyitott (klub-)kérdés, lásd a C10 jelentést.
 * A React-kulcs ettől független: a választók `renderOption`-je a `userId`-t használja kulcsnak
 * (a MUI alapból a címkét tenné kulcsnak, ami azonos nevűeknél ütközne).
 */
export function userOptionLabel(user: { name?: string | null; email?: string | null }): string {
  const name = user.name ?? '';
  const email = user.email ?? '';
  // Csupa szóköz is „nincs e-mail" — különben „Név ( )" lenne a címke.
  return email.trim() ? `${name} (${email})` : name;
}
